import { Route } from 'react-router-dom'

import ProfileMiddleware from '../middlewares/ProfileMiddleware'
import MaybeProfileMiddleware from '../middlewares/MaybeProfileMiddleware'

import PageProfile from '../pages/tabs/Profile/PageProfile'
import PageSearch from '../pages/tabs/Search/PageSearch'
import PageFeed from '../pages/tabs/Feed/PageFeed'
import PageNotifications from '../pages/tabs/Notifications/PageNotifications'
import PageShowUser from '../pages/tabs/ShowUser/PageShowUser'
import PageExit from '../pages/tabs/Exit/PageExit'
import PageApps from '../pages/static/Apps/PageApps'

export const RoutesProfile = [
    <Route path="/profile" element={<ProfileMiddleware><PageProfile /></ProfileMiddleware>} key="route-u-profile" />,
    <Route
        path="/show/id/:id"
        element={<MaybeProfileMiddleware><PageShowUser format="id" side={true} /></MaybeProfileMiddleware>}
        key="route-u-show-profile-id" />,
    <Route
        path="/show/:username"
        element={<MaybeProfileMiddleware><PageShowUser format="username" side={true} /></MaybeProfileMiddleware>}
        key="route-u-show-profile-username" />,
    <Route path="/search" element={<MaybeProfileMiddleware><PageSearch /></MaybeProfileMiddleware>} key="route-u-search" />,
    <Route path="/feed" element={<MaybeProfileMiddleware><PageFeed /></MaybeProfileMiddleware>} key="route-u-feed" />,
    <Route path="/notifications" element={<ProfileMiddleware><PageNotifications /></ProfileMiddleware>} key="route-u-notifications" />,

    <Route path="/exit" element={<PageExit />} key="route-u-exit" />,
    <Route path="/apps" element={<PageApps />} key="route-apps" />,
]
